// Поля-«слоты» закупщиков создаются динамически вида `proc_<userId>`.
// Узкая index signature на префикс `proc_` сохраняет keyof TableRow
// в рамках string (template literal union) и не ломает места, где
// ожидается string.
export interface TableRow {
  id: string
  clientName: string
  requestId: string
  code: string
  clientCategory: string
  date: string
  partNumber: string
  brand: string
  qty: number | null
  unit: string
  totalY: number | null
  soprovod: string
  priority: string
  deadline: string
  comments: string
  targetPrice: number | null
  status: string
  /** Закупщицкий флаг: заявка в QUOTE_SENT/CLOSED_WON/CLOSED_LOST →
   *  позиция уезжает в блок «Обработанные». Локальное поле, в API не уходит. */
  isProcessed?: boolean
  [procField: `proc_${string}`]: string | undefined
}

/** Префикс поля-слота закупщика */
export const PROC_FIELD_PREFIX = 'proc_'

/** Построить имя поля-слота для заметки закупщика по userId */
export function procField(userId: string): string {
  return `${PROC_FIELD_PREFIX}${userId}`
}

/** Извлечь userId из имени поля-слота (null если это не слот закупщика) */
export function procUserIdFromField(field: string): string | null {
  return field.startsWith(PROC_FIELD_PREFIX) ? field.slice(PROC_FIELD_PREFIX.length) : null
}

/** Статические колонки (без слотов закупщиков) — клипборд, экспорт и пр. */
export const COL_FIELDS: (keyof TableRow)[] = [
  'clientName',
  'requestId',
  'code',
  'clientCategory',
  'date',
  'partNumber',
  'brand',
  'qty',
  'unit',
  'totalY',
  'soprovod',
  'priority',
  'deadline',
  'comments',
  'targetPrice',
  'status',
]

export type RowSize = 'compact' | 'normal' | 'tall'

export const ROW_HEIGHTS: Record<RowSize, number | undefined> = {
  compact: 28,
  normal: 42,
  tall: undefined,
}
